import cn from 'classnames'
import { tr, useGlobalMaintenanceMode } from 'mmfintech-commons'
import styles from './MaintenanceModal.module.scss'

const MaintenanceModal = () => {
  const isMaintenanceMode = useGlobalMaintenanceMode()

  return isMaintenanceMode ? (
    <div className={cn(styles['maintenance-wrapper'], 'maintenance-modal')}>
      <div className={cn(styles['maintenance-container'], 'container')}>
        <div className={cn(styles['maintenance-heading'], 'heading')}>
          {tr('FRONTEND.MAINTENANCE.HEADING', 'Maintenance')}
        </div>
        {tr(
          'FRONTEND.MAINTENANCE.BODY',
          'We are currently performing scheduled maintenance. Please check back shortly. We apologize for any inconvenience.'
        )}
      </div>
    </div>
  ) : null
}

export default MaintenanceModal
